<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from "echarts"
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '550px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el)
      this.setOptions(this.chartData)
    },
    setOptions({data}=[]) {
      this.chart.setOption({
        title: {
          text: '代理商直接下级月销售排名'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
        dataset: [
            {
              dimensions: ['name', 'number','sale'],
              source: data
            },
            {
              transform: {
                type: 'sort',
                config: { dimension: 'sale', order: 'desc' }
              }
            }
        ],
        xAxis: {
          type: 'category',
          axisLabel: { interval: 0, rotate: 90 }
        },
        yAxis: {},
        series: {
          type: 'bar',
          encode: { x: 'name', y: 'sale' },
          datasetIndex: 1
        }
      });

    }
  }
}
</script>
